export function utob(toEncode: string): string {
  return decodeURIComponent(atob(toEncode));
}

export function btou(toDecode: string): string {
  return btoa(encodeURIComponent(toDecode));
}
